import { useNavigate } from "react-router-dom";
import PublicLoginHeader from "../../components/auth/PublicLoginHeader";
import StoreBadges from "../../components/marketing/StoreBadges";
import TestimonialsCarousel from "../../components/marketing/TestimonialsCarousel";
import { BRAND_NAME } from "../../constants/brand";
import "../../styles/auth.css";
import "../../styles/publicLogin.css";

const FEATURES = [
  {
    title: "Multi-Tenant Repo Agencies",
    text: "Manage multiple repo agencies, branches, and legal recovery operations from a single secure platform.",
  },
  {
    title: "Role-Based Secure Access",
    text: "Give admins, managers, and legal recovery agents the right access to the right information.",
  },
  {
    title: "Real-Time Operations",
    text: "Track legal recovery activities, vehicle cases, agents, and field operations in real time.",
  },
  {
    title: "Powerful Analytics & Automation",
    text: "Turn legal recovery data into actionable insights with streamlined workflows and automated operations.",
  },
];

export default function Login() {
  const navigate = useNavigate();

  return (
    <div className="public-login-page">
      <PublicLoginHeader />
      <div className="auth-container login-portal-container public-login-landing public-login-landing--hero">
        <div className="login-portal-shape login-portal-shape-one" aria-hidden />
        <div className="login-portal-shape login-portal-shape-two" aria-hidden />
        <div className="login-portal-grid-bg" aria-hidden />

        <div className="login-portal-layout login-portal-layout--hero-only">
          <div className="login-portal-content">
            <div className="login-brand-lockup">
              <div className="login-brand-icon" aria-hidden>
                FR
              </div>
            </div>

            <h1 className="login-brand-wordmark" aria-label={BRAND_NAME}>
              <span className="login-brand-fast">Fast</span>
              <span className="login-brand-recovery">Recovery</span>
            </h1>

            <p className="login-portal-tagline">
              One Finance Vehicle Searching powerful platform for Banks / NBFCs and Legal Recovery Agencies
            </p>

            <p className="login-portal-subtitle">
            Transform vehicle legal recovery and legal repossession operations with a
            secure, unified platform built for modern legal recovery teams.
            </p>

            <p className="login-portal-lead">
              Manage cases. Track vehicles. Coordinate agents. Monitor
              operations — all from one platform.
            </p>

            <section className="login-portal-features" aria-labelledby="login-features-heading">
              <h2 id="login-features-heading" className="login-portal-features__title">
              Built for Legal Recovery Operations
              </h2>

              <div className="login-portal-features__grid">
                {FEATURES.map((feature, i) => (
                  <article
                    key={feature.title}
                    className="login-portal-feature"
                    style={{ animationDelay: `${0.12 + i * 0.08}s` }}
                  >
                    <h3 className="login-portal-feature__title">{feature.title}</h3>
                    <p className="login-portal-feature__text">{feature.text}</p>
                  </article>
                ))}
              </div>
            </section>

            <TestimonialsCarousel />

            <StoreBadges
              className="login-store-badges"
              title="Get the Fast Recovery app"
              variant="dark"
            />

            <p className="auth-link login-portal-register-hint login-portal-register-hint--inline">
              <span onClick={() => navigate("/register")}>
              Create Your Repo Agency Account or Register as a Repo Agent.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
